import { cn } from "src/lib/cn";
import { getStyleExampleSrc } from "./lib/styleExamples";

interface StyleThumbnailProps {
  styleId: string;
  /** Square edge length in px. */
  size: number;
  className?: string;
}

export default function StyleThumbnail({ styleId, size, className }: StyleThumbnailProps) {
  const src = getStyleExampleSrc(styleId);
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      aria-hidden="true"
      className={cn("shrink-0 object-cover", size >= 40 ? "rounded-xl" : "rounded-[5px]", className)}
      style={{ width: size, height: size }}
    />
  );
}
